import React from 'react';

import Layout from '../components/layout';
import Seo from '../components/seo';

import Header from '../components/Header/Header';
import IntroSection from '../components/AboutUs/IntroSection/IntroSection';
import FirstQuote from '../components/AboutUs/FirstQuote/FirstQuote';
import SecondQuote from '../components/AboutUs/SecondQuote/SecondQuote';
import HumanFeature from '../components/AboutUs/HumanFeature/HumanFeature';
import TeamSection from '../components/AboutUs/TeamSection/TeamSection';

import Customers from '../components/shared/Customers/Customers';
import FinalCta from '../components/shared/FinalCta/FinalCta';

const AboutUs = () => (
  <Layout>
    <Header demoButtonNavigation="/book-demo" />
    <Seo
      title="Edwin - Cybersecurity designed for humans"
      description="Edwin is a behavioral cybersecurity platform that helps organizations reduce security risks, comply with policies, and shape their security culture through small, ongoing, and verifiable security missions."
    />
    <IntroSection />
    <FirstQuote />
    <TeamSection />
    <SecondQuote />
    <HumanFeature />
    <Customers />
    <FinalCta />
  </Layout>
);

export default AboutUs;
